import { type Language, pathNames } from "@app/constants";

interface Messages {
	accountSettings: string;
	add: string;
	change: string;
	clientName: string;
	dashboard: string;
	default: {
		clientName: string;
		contactNumber: string;
		email: string;
		emailAddress: string;
		rmFirstName: string;
		rmLastName: string;
	};
	logout: string;
	menu: string;
	relationshipManager: string;
	trades: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		accountSettings: pathNames["en"].account,
		add: "(add)",
		change: "(change)",
		clientName: "...",
		dashboard: pathNames["en"].dashboard,
		default: {
			clientName: "...",
			contactNumber: "...",
			email: "...",
			emailAddress: "...",
			rmFirstName: "...",
			rmLastName: "",
		},
		logout: pathNames["en"].logout,
		menu: "Menu",
		relationshipManager: "Your Relationship Manager",
		trades: pathNames["en"].trades,
	},
};

export default messages;
